import { useAppContext } from "app/AppContext";
import FazendaForm from "entity/Fazenda/components/FazendaForm";
import FazendaConsulta from "entity/Fazenda/components/FazendaConsulta";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsAdmin } from "useAuth";

export default function RoutesMenusFazenda() {
    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();

    const isAdmin = useIsAdmin();

    useEffect(() => {

        if (isAdmin) {
            // addMenu({
            //     uid: "fazenda",
            //     text: "Nova Fazenda",
            //     sequence: "222222",
            //     action: () => {
            //         navigate("/fazenda");
            //     },
            // });

            addRoute({ uid: "fazenda", title: "Fazenda", route: "fazenda", element: <FazendaForm /> });


            addMenu({
                uid: "consultaFazenda",
                text: "Fazendas",
                sequence: "222223",
                iconName: "AutoAwesomeMosaic",
                action: () => {
                    navigate("/consulta-fazenda");
                },
            });

            addRoute({ uid: "consultaFazenda", title: "Fazendas", route: "consulta-fazenda", element: <FazendaConsulta /> });
        }

        return () => {
            removeMenusRoutes(["fazenda", "consultaFazenda"]);
        };
    }, [addMenu, addRoute, isAdmin, navigate, removeMenusRoutes]);

    return null;
}
